<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <div class="table-top">
          <el-button class="new-btn" @click="newOrder">
            <i class="el-icon-plus"></i>
            创建
          </el-button>
          <el-input
            class="search-input"
            placeholder="请输入搜索内容"
            v-model="search_name"
            :header-cell-style="getRowClass"
            prefix-icon="el-icon-search" @keyup.enter.native="searchName">
          </el-input>
        </div>
        <el-table
          :data="tableData"
          class="table-container"
          :header-cell-style="getRowClass"
          v-loading="loading"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="lab_order_id"
            label="订单号" width=80>
          </el-table-column>
          <el-table-column
            prop="company_name"
            label="公司名称">
          </el-table-column>
          <el-table-column
            prop="total"
            label="总价" width=80>
          </el-table-column>
          <el-table-column
            prop="create_date"
            label="订单时间" width=140>
          </el-table-column>
          <el-table-column
            prop="days"
            label="期限" width=50>
          </el-table-column>
          <el-table-column
            prop="amount"
            label="数量" width=50>
          </el-table-column>
          <el-table-column label="操作" width=210>
            <template slot-scope="scope">
              <el-button
                size="mini" class="detail-btn" @click="handleSeeDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-container">
          <el-pagination
            background
            layout = "total, prev, pager, next"
            v-if="total>0"
            :page-size="limit"
            :total = "total"
            :current-page = "page"
            @current-change = "currentPageFun"
            >
          </el-pagination>
        </div>
      </div>
    </div>
    <search-company v-if="newOrderShow" @closeorder="close"></search-company>
  </div>
</template>

<script type='text/ecmascript-6'>
import SearchCompany from 'components/SearchCompany.vue'
export default {
  data () {
    return {
      empty: '没有历史订单',
      tableData: [],
      page: 1,
      limit: 10,
      total: 0,
      search_name: '',
      newOrderShow: false,
      search_show: false
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
    this.loading = true
  },
  created () {
    this.initData()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    initData () {
      let that = this
      this.$api.remindOrder({
        page_num: (that.page-1)  * this.limit
      }).then(res => {
        that.loading = false
        if (res.data.detail.length > 0) {
          that.tableData = res.data.detail
          that.total = Number(res.data.total)
        } else {
          that.tableData = res.data.detail
          that.total = 0
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    currentPageFun (page) {  // 点击 页码
      this.page = page
      if (this.search_show) {
        this.searchName()
      } else {
        this.initData()
      }
    },
    newOrder () { // 创建新的订单
      this.newOrderShow = true
    },
    searchName () { // 输入名字搜索
      let that = this
      if (!this.search_show) {
        this.search_show = true
        this.page = 1
      }
      if (that.search_name) {
        this.$api.searchRemind({
          search: that.search_name,
          page_num: (that.page-1) * this.limit
        }).then(res => {
          if (res.data.detail.length > 0) {
            that.tableData = res.data.detail
            that.total = Number(res.data.total)
          } else {
            that.tableData = []
            that.total = 0
          }
        }).catch(err => {
          that.$message({
            message: err,
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        })
      } else {
        that.$message({
          type: 'error',
          message: '搜索不能为空！！',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    close () { // 监听自定义的
      let that = this
      that.newOrderShow = false
    },
    handleSeeDetail (row) { // 点击详情
      this.$router.push({
        path: '/orderDetail',
        query: { lab_order_id: row.lab_order_id, type: row.type}
      })
    }
  },
  components: {
    SearchCompany
  },
  watch: {
    /* '$route': 'initData', */
  }
}
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/box.styl'
</style>